import axios from "axios";
const marketingToken =
  "EAAHebhreyAwBAMYSLfyczl5V4rgeIKj1en3GBcM0myP6bqPHAAJwoEZCtZBlcuZC6n55ZAC1kfAO6GcA3fqsMUX22ER7d0OeHtORkCruqhERMndcFJRYlNtIui0qbnwQICh2tu5u59b7Nfv0hnZA4YP6mG7T6faTrjO7tWfqLccDiolYOVNNiOvaSc4P9zUhfBdm5dM091QZDZD";

export const fbClient = axios.create({
  baseURL: "https://graph.facebook.com/v15.0/",
  params: {
    access_token: process.env.NEXT_PUBLIC_FB_SYSTEM_USER,
  },
});

export const adAccountFields = [
  "id",
  "account_id",
  "account_status",
  "age",
  "agency_client_declaration",
  "amount_spent",
  "balance",
  "business",
  "business_city",
  "business_country_code",
  "business_name",
  "business_state",
  "business_street",
  "business_street2",
  "business_zip",
  "can_create_brand_lift_study",
  "capabilities",
  "created_time",
  "currency",
  "direct_deals_tos_accepted",
  "disable_reason",
  "end_advertiser",
  "end_advertiser_name",
  "existing_customers",
  "extended_credit_invoice_group",
  "failed_delivery_checks",
  "fb_entity",
  "funding_source",
  "funding_source_details",
  "has_migrated_permissions",
  "io_number",
  "is_attribution_spec_system_default",
  "is_direct_deals_enabled",
  "is_in_3ds_authorization_enabled_market",
  "is_notifications_enabled",
  "is_personal",
  "is_prepay_account",
  "is_tax_id_required",
  "line_numbers",
  "media_agency",
  "min_campaign_group_spend_cap",
  "min_daily_budget",
  "name",
  "offsite_pixels_tos_accepted",
  "owner",
  "partner",
  "rf_spec",
  "spend_cap",
  "tax_id",
  "tax_id_status",
  "tax_id_type",
  "timezone_id",
  "timezone_name",
  "timezone_offset_hours_utc",
  "tos_accepted",
  "user_tasks",
  "user_tos_accepted",
];
